import React, { useCallback, useMemo, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import BannerPromo from "../modules/banner-promo";
import ProductApp from "../modules/product-app";
import ProductTag from "../modules/product-tag";
//import ProductDetailDimensions from "./product-detail-dimensions";
import placeholderImg from "../../images/placeholder.png";
import GalleryProduct from "../modules/gallery-product";
import GalleryModal from "../modules/gallery-modal";

const ProductDetailImage = ({ product, app, tags, badge, bannerPromo, config, pagePath }) => {
  const {
    otherImages,
    s3Images,
    primaryThumb,
    primaryMedium,
    primaryFull,
    otherThumb,
    otherMedium,
    otherFull,
    s3Thumb,
    s3Medium,
    s3Full,
    productName,
    key_prod,
    url360,
    //dimensions,
    //dimensionsPack,
    productVideo,
    familiesIds,
  } = product;

  const enhanced = s3Images?.length > 0;
  const imgTitle = `${productName} ${key_prod}`;

  const youtubeId = useMemo(() => {
    // Video del prodotto, fallback su video famiglia
    const video = productVideo
      ? productVideo
      : familiesIds.length && familiesIds[0].video
      ? familiesIds[0].video
      : null;
    return video ? video.split("/").reverse()[0] : null;
  }, [familiesIds, productVideo]);
  // const offset = youtubeId ? 1 : 0 + (url360 ? 1 : 0);

  const s3SlidesData = useMemo(
    () =>
      enhanced
        ? s3Images.map((_full, i) => ({
            thumb: s3Thumb[i]?.find((item) => item.imageType === "640") || placeholderImg,
            medium: s3Medium[i]?.find((item) => item.imageType === "640") || placeholderImg,
            full: s3Full[i]?.find((item) => item.imageType === "M") || placeholderImg,
            title: imgTitle,
            s3Images: true,
          }))
        : [],
    [enhanced, s3Images, s3Full, s3Medium, s3Thumb, imgTitle]
  );

  const slidesData = useMemo(() => {
    return [
      {
        thumb: primaryThumb?.find((item) => item.imageType === "640") || placeholderImg,
        medium: primaryMedium?.find((item) => item.imageType === "640") || placeholderImg,
        full: primaryFull?.find((item) => item.imageType === "M") || placeholderImg,
        title: imgTitle,
      },
    ].concat(
      otherImages
        ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
        .map((_full, i) => ({
          thumb:
            otherThumb
              ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
              ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
          medium:
            otherMedium
              ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
              ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
          full:
            otherFull
              ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
              ?.[i]?.find((item) => item.imageType === "M") || placeholderImg,
          title: imgTitle,
        }))
    );
  }, [
    otherImages,
    primaryThumb,
    primaryMedium,
    primaryFull,
    otherThumb,
    otherMedium,
    otherFull,
    imgTitle,
  ]);

  const primarySlidesData = useMemo(() => {
    return [
      {
        thumb: primaryThumb?.find((item) => item.imageType === "640") || placeholderImg,
        medium: primaryMedium?.find((item) => item.imageType === "640") || placeholderImg,
        full: primaryFull?.find((item) => item.imageType === "M") || placeholderImg,
        title: imgTitle,
      },
    ];
  }, [primaryThumb, primaryMedium, primaryFull, imgTitle]);

  const otherSlidesData = useMemo(() => {
    return otherImages
      .filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
      .map((_full, i) => ({
        thumb:
          otherThumb
            ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
        medium:
          otherMedium
            ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
        full:
          otherFull
            ?.filter((item) => item?.find((elem) => !elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "M") || placeholderImg,
        title: imgTitle,
      }));
  }, [otherFull, otherImages, otherMedium, otherThumb, imgTitle]);

  const designSlidesData = useMemo(() => {
    return otherImages
      .filter((item) => item?.find((elem) => elem?.imageUrl?.includes("_n_")))
      .map((_full, i) => ({
        thumb:
          otherThumb
            ?.filter((item) => item?.find((elem) => elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
        medium:
          otherMedium
            ?.filter((item) => item?.find((elem) => elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "640") || placeholderImg,
        full:
          otherFull
            ?.filter((item) => item?.find((elem) => elem?.imageUrl?.includes("_n_")))
            ?.[i]?.find((item) => item.imageType === "M") || placeholderImg,
        title: imgTitle,
        dimensions: true,
      }));
  }, [otherFull, otherImages, otherMedium, otherThumb, imgTitle]);

  const isFirstImageS3Present =
    s3SlidesData?.length > 0 && !s3Images?.find((image) => image?.[0]?.imageUrl?.includes("_000."));

  const url360Slide = url360
    ? {
        ...slidesData[0],
        url360,
      }
    : null;
  const youtubeSlide = youtubeId
    ? {
        ...slidesData[0],
        youtubeId,
      }
    : null;

  const allSlidesData = (
    isFirstImageS3Present
      ? primarySlidesData.concat(s3SlidesData).concat(otherSlidesData)
      : s3SlidesData.concat(slidesData)
  )
    .concat(url360Slide)
    .concat(designSlidesData)
    .concat(youtubeSlide)
    .filter(Boolean);

  const { labelManagerLabels, site } = useStaticQuery(graphql`
    {
      labelManagerLabels {
        pdpProductDimensions
        packagingLabel
        pricePercentageTooltip
        save
        galleryAll
        galleryDimensions
        galleryVideo
        gallery360
        cookieGalleryButton
        cookieGalleryButtonManage
        video
      }
      site {
        siteMetadata {
          priceLanguage
        }
      }
    }
  `);

  const [zoomIdx, setZoomIdx] = useState(-1);
  const showZoom = useCallback((e) => {
    const index = parseInt(e.currentTarget.name);
    setZoomIdx(index);
  }, []);
  const closeZoom = () => setZoomIdx(-1);

  return (
    <div className="pdp-main-info__image">
      <div className="pdp-product-gallery">
        {tags?.length > 0 ? (
          <div className="product-card__tags product-card__tags__pdp">
            {tags.map((tag) => (
              <ProductTag
                data={tag}
                key={tag.id}
                config={config}
                labelManagerLabels={labelManagerLabels}
                siteMetadata={site.siteMetadata}
              />
            ))}
          </div>
        ) : null}
        <GalleryProduct
          slides={allSlidesData}
          badge={badge}
          enhanced={enhanced}
          labelManagerLabels={labelManagerLabels}
          showZoom={showZoom}
          pagePath={pagePath}
        />
        <GalleryModal
          slides={allSlidesData}
          badge={badge}
          enhanced={enhanced}
          labelManagerLabels={labelManagerLabels}
          showZoom={showZoom}
          zoomIdx={zoomIdx}
          closeZoom={closeZoom}
          key={`${zoomIdx >= 0}`}
          pagePath={pagePath}
        />
      </div>
      {!!bannerPromo.length && <BannerPromo data={bannerPromo[0]} origin="pdp" />}
      {app && <ProductApp app={app} />}
      {/*  <ProductDetailDimensions
        dimensions={dimensions}
        dimensionsPack={dimensionsPack}
        dimensionsLabel={labelManagerLabels.pdpProductDimensions}
        dimensionsPackLabel={labelManagerLabels.packagingLabel}
      /> */}
    </div>
  );
};

export default ProductDetailImage;
